import type {
  DonationComment,
  DonationPost,
  DonationUser,
} from '../components/CardDonationPost/CardDonationPost';
import type { BookRequest } from '../types/bookRequest.types';
import type { CommunityAuthor, CommunityComment } from '../types/community.types';

/** Shown when the account has no display name (the API never publishes the email) */
export const AUTHOR_FALLBACK = 'Pengguna';

const toUser = (author: CommunityAuthor): DonationUser => ({
  name: author.name || AUTHOR_FALLBACK,
  avatar: author.picture_url ?? undefined,
});

/** A comment of either board (Donasi, Media) */
export const toDonationComment = (row: CommunityComment): DonationComment => ({
  id: row.id,
  user: toUser(row.author),
  content: row.content,
  createdAt: row.created_at,
  likes: row.like_count,
  isLiked: row.liked_by_me,
  canDelete: row.is_mine,
});

export const toDonationPost = (
  row: BookRequest,
  comments: CommunityComment[] = []
): DonationPost => ({
  ...toDonationComment(row),
  comments: comments.map(toDonationComment),
  commentCount: row.comment_count,
});
